import { MatchPredictionVariant } from "./utils/matchPrediction.types";
import type { MatchPredictionState } from "./utils/matchPrediction.types";
import { shareableLink } from "./utils/shareableLink";
import { isNullable } from "@/types/isNullable";

export enum ActionTypes {
  FETCH_MATCH_PREDICTION_REQUEST = "FETCH_MATCH_PREDICTION_REQUEST",
  FETCH_MATCH_PREDICTION_SUCCESS = "FETCH_MATCH_PREDICTION_SUCCESS",
  FETCH_MATCH_PREDICTION_FAILURE = "FETCH_MATCH_PREDICTION_FAILURE",
}
interface FetchMatchPredictionRequestAction {
  type: ActionTypes.FETCH_MATCH_PREDICTION_REQUEST;
  payload: MatchPredictionVariant;
}
interface FetchMatchPredictionSuccessRequestAction {
  type: ActionTypes.FETCH_MATCH_PREDICTION_SUCCESS;
  payload: MatchPredictionState;
}
interface FetchMatchPredictionSuccessFailureAction {
  type: ActionTypes.FETCH_MATCH_PREDICTION_FAILURE;
  payload: string;
}

export type Actions =
  | FetchMatchPredictionRequestAction
  | FetchMatchPredictionSuccessRequestAction
  | FetchMatchPredictionSuccessFailureAction;

const PREDICTION_INCREASE = 1;

export const matchPredictionReducer = (
  state: MatchPredictionState,
  action: Actions,
): MatchPredictionState => {
  switch (action.type) {
    case ActionTypes.FETCH_MATCH_PREDICTION_REQUEST:
      if (isNullable(state.persistedUserPrediction)) {
        return {
          ...state,
          persistedUserPrediction: action.payload,
        };
      }
      return state;
    case ActionTypes.FETCH_MATCH_PREDICTION_SUCCESS:
      switch (state.persistedUserPrediction) {
        case MatchPredictionVariant.Home:
          return {
            ...state,
            home: {
              ...state.home,
              predictions: state.home.predictions + PREDICTION_INCREASE,
            },
            share: {
              buttonText: state.shareButton?.text ?? "",
              trackingEvents: state.shareButton?.trackingEvents ?? [],
              shareText: action.payload.shareText ?? "",
              shareTitle: state.title,
              shareUrl: shareableLink(),
            },
            totalPredictions: state.totalPredictions + PREDICTION_INCREASE,
          };
        case MatchPredictionVariant.Draw:
          return {
            ...state,
            draw: {
              ...state.draw,
              predictions: state.draw.predictions + PREDICTION_INCREASE,
            },
            share: {
              buttonText: state.shareButton?.text ?? "",
              trackingEvents: state.shareButton?.trackingEvents ?? [],
              shareText: action.payload.shareText ?? "",
              shareTitle: state.title,
              shareUrl: shareableLink(),
            },
            totalPredictions: state.totalPredictions + PREDICTION_INCREASE,
          };
        case MatchPredictionVariant.Away:
          return {
            ...state,
            away: {
              ...state.away,
              predictions: state.away.predictions + PREDICTION_INCREASE,
            },
            share: {
              buttonText: state.shareButton?.text ?? "",
              trackingEvents: state.shareButton?.trackingEvents ?? [],
              shareText: action.payload.shareText ?? "",
              shareTitle: state.title,
              shareUrl: shareableLink(),
            },
            totalPredictions: state.totalPredictions + PREDICTION_INCREASE,
          };
        default:
          return state;
      }
    default:
      throw new Error("Invalid action type");
  }
};
